import { z } from 'zod';
/**
 * The player's profile window. The client asks (`profile`, no payload) and
 * the server answers its owner alone: what only the server counts, the
 * career. Level, gear, gold and portals the client already holds from its
 * own messages, so they are not repeated here.
 */
const Count = z.number().int().min(0);
/**
 * A character's career, counted by the zone and saved with its progress.
 * Every field defaults, so a row written before a counter existed parses.
 */
export const CareerSchema = z.object({
    /** Kills by mob id: the hunting record and every total derive from it. */
    kills: z.record(z.string().min(1), Count).default({}),
    deaths: Count.default(0),
    tilesWalked: Count.default(0),
    playSeconds: Count.default(0),
    spellsCast: Count.default(0),
    itemsLooted: Count.default(0),
    damageDealt: Count.default(0),
    /** The strongest single blow, swing or spell. */
    bestHit: Count.default(0),
    /** Camp chests opened after their clear, by biome (ADR 0046). */
    camps: z.record(z.string().min(1), Count).default({}),
    /** World events won over the threshold (ADR 0050). */
    events: Count.default(0),
    /** Attempts at the smith, success or failure (ADR 0051). */
    upgrades: Count.default(0),
    /** Shefira slain in a raid (ADR 0068): the Company's vow counts them. */
    shefiraKills: Count.default(0),
    /**
     * Of `kills`, those shared by a party member who did not hunt the mob
     * themself (ADR 0047): they count everywhere but in a quest, or a strong
     * friend without the quest would do it for you.
     */
    lentKills: z.record(z.string().min(1), Count).default({}),
    /**
     * Item templates each creature dropped for this character, by mob id: the
     * hunting log's « loot already seen » (ADR 0093), counted from its release.
     */
    lootSeen: z.record(z.string().min(1), z.array(z.string().min(1))).default({}),
});
/** Nothing to say but "show me": the server knows whose profile it is. */
export const ProfileRequestSchema = z.object({}).strict();
export const ProfileEventSchema = z.object({
    career: CareerSchema,
    /** When the character was created, ISO 8601. */
    createdAt: z.string().min(1),
});
//# sourceMappingURL=profile.js.map